import { useQuery } from "@tanstack/react-query";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAnalysisQueryKeys } from "./queryKeyFactory";

type QueryOptions = {
    domain?: string;
    isEnabled?: boolean;
};

export default function useCompanyCardQuery(options: QueryOptions = {}) {
    const { params } = useCurrentStateAndParamsWithFixedDomain();

    const domain = options.domain ?? params.key;
    const isEnabled = options.isEnabled ?? true;

    return useQuery({
        queryKey: companyAnalysisQueryKeys.companyCard(domain),
        enabled: isEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        refetchOnMount: true,
        queryFn({ signal }) {
            return salesApiService.companyAnalysis.fetchCompanyCard(domain, {
                cancellation: signal,
            });
        },
    });
}
